<template>
    <div :class="['loginBox', {active: isCustomLogin}]" v-if="isCustomLogin != 'pending'" :style="customStyle.rootStyle">
        <!-- 自定义登录头部 -->
        <div class="header" v-if="isCustomLogin">
            <div style="display: flex; align-items: center;">
                <img class="logo" :src="$global.imgUrl + configInfo.periodicalLogo">
                <div>{{ configInfo.title }}</div>
            </div>
            <div>
                <template v-for="(item, index) in configInfo.associationOption">
                    <a
                        :key="index"
                        v-if="item.linKAddress"
                        target="_blank"
                        :href="item.linKAddress"
                    >
                        {{ item.linKName }}
                    </a>
                    <span v-else>{{ item.linKName }}</span>
                </template>
            </div>
        </div>

        <!-- 登录框 -->
        <div class="loginRight">
            <div class="cover-content" v-if="isCustomLogin">
                <img :src="$global.imgUrl + configInfo.loginPage" :style="customStyle.coverStyle" />
                <div class="cover-title">{{ configInfo.publicationsName }}</div>
            </div>
            <div class="login-content">
                <div class="rightTop">
                    <ul  value="tabs" v-if="tabs != '注册' && tabs != '忘记密码'">
                        <li 
                            class="li" 
                            v-text="item.label" 
                            v-for="(item, index) in tabList" 
                            :key="index" 
                            @click="tabChange(item)"
                            :class="item.label == tabs ? 'lis' : ''">
                        </li>
                    </ul>
                    <p v-if="tabs == '注册'" class="li">欢迎注册</p>
                    <p v-if="tabs == '忘记密码'" class="li">忘记密码</p>
                </div>
                <div class="rightCenter">
                    <Form :label-width="0" :model="loginParams" :rules="ruleValidate" ref="loginParams">
                        <FormItem prop="userName">
                            <Input 
                                type="text" 
                                v-model.trim="loginParams.userName" 
                                placeholder="请输入手机号"
                                @keyup.enter.native="keyupClick(tabs == '密码登录' ? 'mima' : 'code')" 
                            />
                        </FormItem>
                        <FormItem v-if="tabs != '密码登录'" prop="validateCode">
                            <Input 
                                type="text" 
                                v-model="loginParams.validateCode" 
                                placeholder="请输入验证码" 
                                ref="code" class="cod"
                                @keyup.enter.native="
                                tabs == '短信登录' ? login('loginParams') : keyupClick('pass')"
                            >
                                <span slot="append" @click="getCode">{{ codeBut }}</span>
                            </Input>
                        </FormItem>
                        <FormItem v-if="tabs == '密码登录'" prop="password">
                            <Input 
                                type="password" 
                                password v-model.trim="loginParams.password" 
                                placeholder="请输入密码" 
                                ref="mima"
                                @keyup.enter.native="login('loginParams')" 
                            />
                        </FormItem>
                        <FormItem v-if="tabs == '注册' || tabs == '忘记密码'" prop="password">
                            <Input 
                                type="password" 
                                password 
                                v-model.trim="loginParams.password" 
                                placeholder="6-20位字母与数字组合" 
                                ref="pass"
                                @keyup.enter.native="keyupClick('pass2')" 
                            />
                        </FormItem>
                        <FormItem v-if="tabs == '注册' || tabs == '忘记密码'" prop="password2">
                            <Input 
                                type="password" 
                                password 
                                v-model.trim="loginParams.password2" 
                                placeholder="请再次确认密码" 
                                ref="pass2"
                                @keyup.enter.native="login('loginParams')" 
                            />
                        </FormItem>
                        <div v-if="tabs == '密码登录'" style="color: #4064e1;  padding-bottom: 30px;" >
                            <span @click="tabs = '忘记密码'" style="cursor: pointer;">忘记密码</span>
                        </div>
                        <Button 
                            @click="login('loginParams')" 
                            class="login"
                            v-text="tabs == '注册' ? '注册' : tabs == '忘记密码' ? '下一步' : '登录'">
                        </Button>
                        <div 
                            v-if="tabs != '注册' && tabs != '忘记密码'" 
                            style="font-size:14px;text-align:center"
                        >
                            还没有账号，免费
                            <span @click="register" style="color: #4064e1; cursor: pointer;">注册</span>
                        </div>
                        <div v-else style="font-size:14px;text-align:center">
                            已有账号，马上
                            <span @click="haveCount" style="color: #4064e1; cursor: pointer;">登录</span>
                        </div>
                        <div v-if="tabs == '注册'" style="font-size:14px;margin-top:14px;">
                            <Checkbox v-model="agree"></Checkbox>
                            我已阅读并接受
                            <span @click="show = true" style="color: #4064e1; cursor: pointer;">&nbsp&nbsp用户协议</span>
                        </div>
                        <!-- <span v-else>已有账号，马上<span @click="tabs = '短信登录'" style="color:#4064E1;cursor: pointer;">登录</span></span> -->
                    </Form>
                </div>
            </div>
        </div>

        <!-- 自定义登录底部 -->
        <div class="footer"  v-if="isCustomLogin">
            <div>
                <template v-for="(item, index) in configInfo.informationOption">
                    <a
                        :key="index"
                        v-if="item.linKAddress"
                        target="_blank"
                        :href="item.linKAddress"
                    >
                        {{ item.linKName }}
                    </a>
                    <span v-else>{{ item.linKName }}</span>
                </template>
            </div>
            <div style="max-width: 748px; padding: 30px 0; line-height: 30px;">{{ configInfo.contactInformation }}</div>
        </div>
        <VerifyCode 
            ref="verifyCode"
            :show="VerifyCodeShow"
            :phone="loginParams.userName"
            @success="handleVerifySuccess"
            @close="handleVerifyClose">
        </VerifyCode>
        <certiFication v-if="livsTop" :livstGithave="livstGithave" :livsTop="livsTop" :toplist="toplist" @gitlist="gitlist"></certiFication>
        <agreement :show="show" @fun="getAgree"></agreement>
    </div>
</template>
  
<script>
var vm;
const url = window.location.search;
const str = url.substring(url.indexOf("?") + 1).split("&");
let obj = {};
str.forEach((it) => {
    obj[it.substring(0, it.indexOf("="))] = it.substring(it.indexOf("=") + 1);
});
const conCheck = (rule, value, callback) => {
    if (!value) {
        callback(new Error("请再次输入密码"));
    } else if (value !== vm.loginParams.password) {
        callback(new Error("两次输入密码不一致!"));
    } else {
        callback();
    }
};
import VerifyCode from "@/components/VerifyCode";
import { phone, password, empty } from "@/const/formValidate.js";
import certification from "@/views/manage/certification/index.vue";
import agreement from "@/components/agreement";
export default {
    components: {
        VerifyCode,
        certiFication: certification,
        agreement: agreement,
    },
    data() {
        return {
            VerifyCodefalg:true,
            VerifyCodeShow:false,
            isCustomLogin: "pending", // 是否展示自定义配置
            configInfo: {}, // 自定义登录配置信息
            justOnce: true,
            livsTop: false,
            tabs: "短信登录",
            confirmSuccess: "",
            codeStatus: true,
            codeBut: "获取验证码",
            codeButShow: true,
            show: false, //注册协议弹框是否打开
            agree: false, //是否同意注册协议
            tabList: [{ label: "短信登录" }, { label: "密码登录" }],
            loginParams: {
                userName: "",
                password: "",
                validateCode: "",
            },
            ruleValidate: {
                userName: phone("手机号", true),
                password: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error("请输入登录密码！"));
                            }
                            if (this.tabs == "密码登录") return callback();
                            if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(value)) {
                                return callback(new Error("密码为6-20位数字字母组合"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
                password2: [
                    {
                        required: true,
                        validator: conCheck,
                        trigger: "blur",
                    },
                ],
                validateCode: empty("验证码"),
            },
            typeList: [
                { name: "平台管理员", userType: "ADMIN_USER" },
                { name: "刊社管理员", userType: "PRESS_USER" },
                { name: "普通管理员", userType: "PER_USER" },
            ],
            userType: "",
            islogin: true,
            perList: [],
            perId: "",
            userInfo: "",
            livstGithave: {},
            listgit: 0,
            toplist: 0,
        };
    },
    watch: {
        tabs(newName, oldName) {
            this.$refs.verifyCode.isSuccess = false
            if (newName) {
                vm.$refs["loginParams"].resetFields();
                vm.loginParams = {
                    userName: "",
                    password: "",
                    validateCode: "",
                };
                clearInterval(this.timer);
                vm.codeBut = "获取验证码";
                vm.codeButShow = false;
                setTimeout(function() {
                    vm.codeButShow = newName != "密码登录" ? true : false;
                }, 100);
            }
        },
        loginParams(table) {
            vm.loginParams = table;
        },
        toplist(datas) {
            vm.toplist = datas;
        },
    },
    created() {
        this.getPk();
        this.queryLoginConfig();
    },
    computed: {
        customStyle() {
            if (!this.isCustomLogin) return {};
            return {
                rootStyle: {
                    backgroundImage: `url(${this.$global.imgUrl +
                        this.configInfo.themeBackground})`,
                },
                coverStyle: {
                    // backgroundImage: `url(${this.$global.imgUrl + this.configInfo.loginPage})`,
                    width: "354px",
                    height: "auto",
                },
            };
        },
    },
    mounted() {
        vm = this;
        vm.getRegister();
        vm.Store = window.sessionStorage;
        if (vm.Store.userInfo) {
            vm.Store.removeItem("userInfo");
        }
        if (!_.isEmpty(vm.$route.query)) {
            vm.loginParams.userType = vm.$route.query.userType;
            vm.loginParams.phone = vm.$route.query.phone;
        }
    },
    methods: {
        // 获取回调
        handleVerifySuccess(){
            this.VerifyCodeShow = false
            let adapter =
                    vm.tabs == "注册"
                        ? "regiter"
                        : vm.tabs == "忘记密码"
                            ? "retrieve_pwd"
                            : "login";
            if (this.justOnce) {
                if (this.codeStatus) {
                    let num = 60;
                    this.justOnce = false;
                    this.timer = setInterval(() => {
                        if (num <= 0) {
                            vm.codeBut = "获取验证码";
                            this.codeStatus = true;
                            this.justOnce = true;
                            clearInterval(this.timer);
                        } else {
                            this.codeStatus = false;
                            vm.codeBut = `${--num}秒后重新获取`;
                        }
                        
                    }, 1000);
                    vm.$apis.manage
                        .sendCode(
                            { phone: vm.loginParams.userName, adapter: adapter },
                            vm.$global.url3
                        )
                        .then((res) => {
                            this.$refs.verifyCode.isSuccess = false
                            if (res.resultCode == 200) {
                                if (vm.tabs == "注册") {
                                    vm.listgit = 1;
                                }
                            } else {
                                vm.$Message.destroy();
                                setTimeout(function() {
                                    vm.$Message.warning(res.resultDesc);
                                }, 100);
                                clearInterval(this.timer);
                                vm.codeBut = "获取验证码";
                                this.codeStatus = true;
                                this.justOnce = true;
                            }
                        });
                }
            }
        },
        // 关闭
        handleVerifyClose(){
            this.VerifyCodeShow = false
        },
        async queryLoginConfig() {
            let perId = this.$route.query.prid ? vm.$route.query.prid : obj.prid;
            if (!perId) return (this.isCustomLogin = false);
            const res = await this.$apis.manage.queryLoginConfig({ perId });
            const { ckeckLoginOpen, periodicalInfo } = res.content;
            if (ckeckLoginOpen != 1) {
                this.isCustomLogin = false;
            } else {
                this.isCustomLogin = true;
                this.configInfo = periodicalInfo;
            }
        },
        getRegister() {
            let perId = vm.$route.query.prid ? vm.$route.query.prid : obj.prid;
            if (!perId) return;
            vm.$apis.manage.getRegister({ perId }).then((res) => {
                var data = [];
                if (res.resultCode == 200) {
                    res.data.forEach((item) => {
                        item.configJsons.forEach((item2) => {
                            data.push(item2);
                        });
                    });
                }
                window.sessionStorage.setItem("getRegister", JSON.stringify(data));
            });
        },
        gitlist(names) {
            this.livsTop = names;
            vm.loginParams = {
                userName: "",
                password: "",
                validateCode: "",
            };
        },
        keyupClick(name) {
            this.$nextTick(() => {
                vm.$refs[name].focus();
            });
        },
        getPk() {
            this.$apis.manage.getPk().then((res) => {
                sessionStorage.setItem("trip", res.content.pk);
                if (res.content.token) {
                    sessionStorage.setItem("token", res.content.token);
                    vm.$router.push({
                        path: "/manage/author",
                    });
                } else {
                    sessionStorage.removeItem("token");
                }
            });
        },
        getSetting() {
            // vm.$apis.manage.getSetting().then((rel) => {
            //           var obj={};
            //           //2)新加个人详细信息
            //           obj.settingData = rel.data;
            //           //3)转字符串
            //           var jsonStr = JSON.stringify(obj);
            //           // 4)重新保存
            //           vm.download_img=rel.data.cityDownUrl;
            //           sessionStorage.setItem('middleSchool',jsonStr);
            //       })
        },
        getDetail() {
            vm.$apis.manage.getUserInfo().then((res) => {
                if (res.resultCode == "200") {
                    if (res.content.detail.userInfo) {
                        if (res.content.detail.userInfo.idCard) {
                            setTimeout(function() {
                                vm.$router.push({
                                    path: "/manage/author",
                                });
                            }, 100);
                        } else {
                            vm.livsTop = true;
                            vm.toplist = 1;
                        }
                    } else {
                        vm.livsTop = true;
                        vm.toplist = 1;
                    }
                } else {
                    vm.$Message.warning(res.resultDesc);
                }
            });
        },
        //登录
        login(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if (vm.tabs == "短信登录" || vm.tabs == "密码登录") {
                        if (vm.tabs == "短信登录") {
                            var data = {
                                userName: vm.loginParams.userName,
                                validateCode: vm.loginParams.validateCode,
                            };
                        } else {
                            var data = {
                                userName: vm.loginParams.userName,
                                password: vm.loginParams.password,
                            };
                        }
                        vm.$apis.manage.login(data, this.$global.url3).then((res) => {
                            if (res.resultCode == 200) {
                                sessionStorage.setItem("account", res.content.account);
                                sessionStorage.setItem("token", res.content.user.tokenJwtSign);
                                setTimeout(function() {
                                    vm.$router.push({
                                        path: "/manage/author",
                                    });
                                }, 100);
                                // window.location.href =
                                //   window.location.protocol +
                                //   `/?token=${user.tokenJwtSign}` +
                                //   "#/manage/author";
                                // vm.getDetail();
                            } else {
                                vm.$Message.destroy();
                                vm.$Message.warning(res.resultDesc);
                            }
                        });
                    } else if (vm.tabs == "忘记密码") {
                        if (vm.loginParams.password2 != vm.loginParams.password) {
                            vm.$Message.destroy();
                            vm.$Message.warning("两次密码不一致");
                        }
                        vm.$apis.manage
                            .userRetrievePwd(
                                {
                                    mobile: vm.loginParams.userName,
                                    pwd: vm.loginParams.password,
                                    validateCode: vm.loginParams.validateCode,
                                },
                                vm.$global.url3
                            )
                            .then((res) => {
                                if (res.resultCode == 200) {
                                    vm.tabs = "密码登录";
                                    vm.$Message.success("重置密码成功");
                                    this.codeStatus = true;
                                    this.justOnce = true;
                                } else {
                                    vm.$Message.destroy();
                                    vm.$Message.warning(res.resultDesc);
                                }
                            });
                    } else {
                        //注册
                        if (vm.listgit == 0) {
                            vm.$Message.destroy();
                            vm.$Message.warning("请获取您的验证码");
                            return;
                        }
                        if (!vm.agree) {
                            vm.$Message.destroy();
                            vm.$Message.warning("请同意用户协议后再注册");
                            return;
                        }
                        if (vm.loginParams.password2 != vm.loginParams.password) {
                            vm.$Message.destroy();
                            vm.$Message.warning("输入的密码不一致");
                            return;
                        }
                        var registerRequest = {
                            userName: vm.loginParams.userName,
                            password: vm.loginParams.password,
                            validateCode: vm.loginParams.validateCode,
                            gatherEdit: true,
                            openId: "",
                        };
                        vm.$apis.manage
                            .register(
                                {
                                    userName: vm.loginParams.userName,
                                    password: vm.loginParams.password,
                                    validateCode: vm.loginParams.validateCode,
                                    rsa: true,
                                },
                                vm.$global.url3
                            )
                            .then((res) => {
                                if (res.resultCode == 200) {
                                    vm.toplist = 0;
                                    vm.$Message.success("注册成功");
                                    this.livstGithave = {
                                        userName: vm.loginParams.userName,
                                        password: vm.loginParams.password,
                                        validateCode: vm.loginParams.validateCode,
                                        rsa: true,
                                    };
                                    this.livsTop = true;

                                    vm.tabs = "密码登录";
                                } else {
                                    vm.$Message.destroy();
                                    vm.$Message.warning(res.resultDesc);
                                }
                            });
                    }
                }
            });
        },
        test(data) {
            vm.confirmSuccess = data;
        },
        //tab切换
        tabChange(item) {
            vm.tabs = item.label;
            this.codeStatus = true;
            this.justOnce = true;
        },
        async getCode() {
            if (this.loginParams.userName) {
                // 手机格式校验
                var reg = /^1[3456789]\d{9}$/;
                if (!reg.test(this.loginParams.userName)) {
                    vm.$Message.destroy();
                    vm.$Message.warning("请输入正确的手机号");
                    return;
                }

                // 手机是否注册校验
                if (vm.tabs != "注册") {
                    const res = await vm.$apis.manage.accountIsExist({
                        account: this.loginParams.userName,
                    });
                    if (res.data) {
                        vm.$Message.destroy();
                        vm.$Message.warning("该手机号未被注册");
                        return;
                    }
                }

           
                if(! this.$refs.verifyCode.isSuccess){
                    vm.VerifyCodeShow = true
                    return
                }

                // if (this.$refs.verifyCode.isSuccess) {
             
                // } else {
                //     // vm.$Message.destroy();
                //     // vm.$Message.warning("请先滑动验证");
                   
                // }
            } else {
                vm.$Message.destroy();
                vm.$Message.warning("请输入手机号");
            }
        },
        //点击注册
        register() {
            this.tabs = "注册";
            this.codeStatus = true;
            this.justOnce = true;
        },
        haveCount() {
            this.tabs = "短信登录";
            this.codeStatus = true;
            this.justOnce = true;
        },
        _login() {
            vm.$Message.destroy(); //销毁提示层
            vm.$apis.manage
                .login(vm.loginParams)
                .then((res) => {
                    if (res.resultCode == 0) {
                        vm.userInfo = res.content.user;
                        vm.userType = res.content.user.userType;
                        vm.$global.saveUserInfo(vm.userInfo);
                        if (vm.userType == "ADMIN_USER") {
                            vm.$router.push({ path: "/manage/mySubmission" });
                        } else if (vm.userType == "PRESS_USER") {
                            vm.$router.push({ path: "/manage/subjectManage" });
                        } else {
                            vm.islogin = false;
                            vm._selPer();
                        }
                    } else {
                        vm.$Message.destroy();
                        vm.$Message.warning(res.resultDesc);
                    }
                })
                .catch((err) => {
                    // alert(JSON.stringify(err));
                    // vm.showErrTip = err.msg;
                });
        },

        // 选择类型
        selectedType(itemType) {
            vm.loginParams.userType = itemType;
        },
        _selPer() {
            vm.$apis.system.selPer(vm.loginParams.phone).then((res) => {
                if (res.resultCode == 0) {
                    vm.perList = res.content.list;
                    vm.perId = vm.perList[0].perId;
                }
            });
        },
        onSelect() {
            vm.userInfo.perId = vm.perId;
            vm.userInfo.perList = vm.perList;
            vm.$global.saveUserInfo(vm.userInfo);
            vm.$router.push({ path: "/configuration/roleMold" });
        },
        getAgree(data) {
            vm.agree = data;
            vm.show = false;
        },
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
};
</script>
  
<style lang="scss" scoped>
/deep/ .ivu-tabs-bar {
    border: none;
}

.loginBox {
    width: 100vw;
    height: 100vh;
    min-height: 590px;
    min-width: 930px;
    //text-align: center;
    vertical-align: middle;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    background: url("../../../assets/images/LOGIN..png") no-repeat;
    background-size: 100% 133%;

    &.active {
        .footer,
        .header {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            display: flex;
            min-height: 58px;
            align-items: center;
            justify-content: space-between;
            padding: 0 200px;
            background-color: #fff;
            color: #333;
            font-size: 16px;

            a {
                color: #333;
                font-size: 16px;
            }
            .logo {
                height: 37px;
                width: auto;
                margin-right: 10px;
            }
        }
        .footer {
            top: auto;
            bottom: 0;
        }
        .loginRight {
            display: flex;
            width: 885px;
            height: 596px;
            padding: 24px 28px;
            background-color: rgba(14, 20, 22, 0.7);
            left: 50%;
            transform: translateX(-50%);
            .cover {
                width: 393px;
                height: 548px;
                flex-shrink: 0;
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100%;
            }
            .login-content {
                flex: 1;
                color: #fff !important;
                padding-left: 54px;
                padding-right: 52px;
            }
            .li {
                color: #fff;
                &.lis {
                    font-weight: bold;
                }
            }
        }
    }

    .loginLeft {
        width: 30vw;
        height: 50vh;
        //background: url('../../assets/images/login.png') ;
    }

    .loginRight {
        width: 400px;
        // height: 50vh;
        // margin-left: 6vw;
        background: #ffffff;
        box-shadow: 5px 6px 16px 2px rgba(10, 11, 41, 0.21);
        border-radius: 10px;
        padding: 40px;
        position: absolute;
        left: calc(67vw - 200px);

        /deep/ .ivu-tabs-tab {
            font-size: 20px;
            font-family: Microsoft YaHei;
            color: #0c0c0c;
            line-height: 36px;
        }

        .login {
            background: #4064e1;
            width: 100%;
            height: 46px;
            margin-top: 30px;
            color: #fff;
            margin-bottom: 30px;
        }

        .rightTop {
            ul {
                display: flex;
                margin-bottom: 40px;

                .lis {
                    font-weight: bold;
                    border-bottom: 4px solid #2645ff;
                }
            }
        }
    }

    .li {
        margin-right: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        color: #0c0c0c;
        line-height: 36px;
        cursor: pointer;
        padding-bottom: 10px;
    }

    /deep/ .ivu-input {
        height: 46px;
    }

    /deep/ .ivu-input-group-append {
        background: #fff;
        cursor: pointer;
    }

    /deep/ .ivu-input-suffix i {
        line-height: 46px;
    }

    @media (max-width: 930px) {
        .loginBox {
            .loginRight {
                left: 400px;
            }
        }
    }
}

.cover-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .cover-title {
        padding-top: 10px;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/manage/loginAdmin/index.vue